module.exports = __webpack_public_path__ + "img/en-bg.33528766.jpg";